var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal modal-filter-details modal-talent-list fade",
      attrs: {
        id: "talent-nofications-modal",
        role: "dialog",
        "aria-labelledby": "talent-nofications-modal-label",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-content" }, [
        _c("div", { staticClass: "modal-header" }, [
          _c(
            "h4",
            {
              staticClass: "modal-title",
              attrs: { id: "talent-nofications-modal-label" },
            },
            [
              _vm._v(
                "Send " +
                  _vm._s(_vm._f("sentenceCase")(_vm.$starLabel)) +
                  " Notifications"
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-body" }, [
          _c(
            "form",
            {
              staticClass: "form-horizontal",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _vm.visible
                ? _c(
                    "talent-filtering",
                    {
                      attrs: {
                        "existing-talent": _vm.existingTalent,
                        booking: _vm.booking,
                      },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "talent-list" }, slot: "talent-list" },
                        _vm._l(_vm.talentWithoutExisting, function (talent) {
                          return _c("booking-talent-notifications-list-item", {
                            key: talent.id,
                            attrs: {
                              "talent-is-already-rejected":
                                _vm.talentIsAlreadyRejected(talent),
                              "handle-add-talent-callback":
                                _vm.handleAddTalentCallback,
                              "handle-reject-talent-callback":
                                _vm.handleRejectTalentCallback,
                              "handle-remove-rejected-talent-callback":
                                _vm.handleRemoveRejectedTalentCallback,
                              "handle-remove-talent-callback":
                                _vm.handleRemoveTalentCallback,
                              talent: talent,
                            },
                          })
                        }),
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "modal-footer" },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-lg btn-danger pull-left",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: { click: _vm.handleResetFilters },
              },
              [_c("i", { staticClass: "fa fa-close" }), _vm._v(" Cancel")]
            ),
            _vm._v(" "),
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-lg btn-primary",
                attrs: {
                  click: _vm.handleSendTalentNotificationsCallback,
                  type: "button",
                },
              },
              [_c("i", { staticClass: "fa fa-check" }), _vm._v(" Save\n      ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }